import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as i1 from 'ngx-toastr';
import { ToastrModule } from 'ngx-toastr';
import { LocalStorageUtils } from '@niceltd/cxone-client-platform-services';
var ToastrType;
(function (ToastrType) {
  ToastrType["System"] = "system";
  ToastrType["User"] = "user";
})(ToastrType || (ToastrType = {}));
class ToastrManager {
  constructor(toastr) {
    this.toastr = toastr;
    this.options = this.toastr.toastrConfig;
  }
  /*@param isSystemMsg
  * @return default options
  * */
  getDefaultOptions(isSystemMsg) {
    const timeOut = LocalStorageUtils.getItem(LocalStorageUtils.KEYS.toastrManagerTimeOut) || 3000;
    return {
      positionClass: 'toast-bottom-right',
      timeOut: timeOut,
      extendedTimeOut: 1000,
      toastClass: isSystemMsg ? ToastrType.System : ToastrType.User,
      closeButton: true
    };
  } /*
    *@param type :type of toaster info, warning etc.
    *@param message :message to be shown on toaster
    *@param title :title to be shown on toaster
    *@param isSystemMsg :show system or user message
    *@param options : for custom toaster config
    *@return void
    * this method is responsible for showing toaster
    * */
  showToaster(type, message, title, isSystemMsg, options) {
    const opt = {
      ...this.options
    };
    const defaultOptions = this.getDefaultOptions(isSystemMsg);
    Object.assign(opt, defaultOptions);
    // Handle custom options provided
    if (options) {
      delete options.timeOut; // prevent timeOut from being customized (CXCOM-16632)
      Object.assign(opt, options || {});
    }
    this.toastr.show(message, title, opt, this.options.iconClasses[type]);
  }
  /** @nocollapse */
  static {
    this.ɵfac = function ToastrManager_Factory(t) {
      return new (t || ToastrManager)(i0.ɵɵinject(i1.ToastrService));
    };
  }
  /** @nocollapse */
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ToastrManager,
      factory: ToastrManager.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToastrManager, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.ToastrService
  }], null);
})();
class ToastrManagerModule {
  /** @nocollapse */static {
    this.ɵfac = function ToastrManagerModule_Factory(t) {
      return new (t || ToastrManagerModule)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ToastrManagerModule
    });
  }
  /** @nocollapse */
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [ToastrManager],
      imports: [CommonModule, ToastrModule.forRoot()]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToastrManagerModule, [{
    type: NgModule,
    args: [{
      declarations: [],
      imports: [CommonModule, ToastrModule.forRoot()],
      providers: [ToastrManager]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { ToastrManager, ToastrManagerModule };
